import React, { useEffect, useState } from "react";

import isEmpty from "../../lib/isEmpty";
import { toastAlert } from "../../lib/toastAlert";

import {
  getAllowNot,
  allowNotify,
  getSystemErr,
  setNotiStatus,
} from "../../actions/users";

// import lib
import { dateTimeFormat } from "../../lib/dateFilter";
import { useNavigate } from "react-router-dom";

export default function SystemError() {
  // state
  const [allowNot, setAllowNot] = useState();
  const [notData, setNotData] = useState([]);
  const [autoLoader, setAutoLoader] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    fetchAllow();
    fetchNotification();
    setNotification();
  }, []);
  const setNotification = async () => {
    try {
      let reqData = { type: "systemError" };
      const { status, result, loading, message, error } = await setNotiStatus(
        reqData
      );
    } catch (err) {}
  };

  const [page, setpagecount] = useState(1);
  const [count, setCount] = useState(0);
  const [canGoBack, setCanGoBack] = useState(false);
  const [canGoNext, setCanGoNext] = useState(true);

  const noOfPages = Math.ceil(count / 10);
  const pagesArr = [...new Array(noOfPages)];

  const onPrevPage = () => {
    setpagecount(page - 1);
  };
  const gotoPage = (data) => {
    setpagecount(data);
  };

  const onNextPage = () => {
    setpagecount(page + 1);
  };
  const onPageSelect = (pageNo) => {
    setpagecount(pageNo);
  };

  useEffect(() => {
    let reqdata = {
      page,
      limit: 10,
    };
    fetchNotification(reqdata);
  }, [page]);

  const fetchAllow = async () => {
    try {
      const { status, result, loading, message, error } = await getAllowNot();
      setAutoLoader(false);
      if (status == "success") {
        setAllowNot(result.systemNotify);
      } else {
        toastAlert("error", message, "autoSelect");
      }
    } catch (err) {}
  };

  const fetchNotification = async (reqdata) => {
    try {
      const { status, result, message } = await getSystemErr(reqdata);
      setAutoLoader(false);
      if (status == "success") {
        setNotData(result.systemData);
        setCount(result.count);
      } else {
        toastAlert("error", message, "autoSelect");
      }
    } catch (err) {}
  };

  const handleAuto = async (e) => {
    try {
      e.preventDefault();
      setAutoLoader(true);
      const { checked } = e.target;
      let reqData = {
        allowNotify: checked,
        type: "system_error",
      };
      const { status, result, loading, message, error } = await allowNotify(
        reqData
      );
      setAutoLoader(false);
      if (status == "success") {
        toastAlert("success", message);
        setAllowNot(result.systemNotify);
      } else {
        toastAlert("error", message, "autoSelect");
      }
    } catch (err) {}
  };

  useEffect(() => {
    if (noOfPages === page) {
      setCanGoNext(false);
    } else {
      setCanGoNext(true);
    }
    if (page === 1) {
      setCanGoBack(false);
    } else {
      setCanGoBack(true);
    }
  }, [noOfPages, page]);
  return (
    <div className="userContent">
      <div className="text-end mb-2">
        <button className="edit_btn" onClick={() => navigate("/dashboard")}>
          Go back
        </button>
      </div>
      <div className="flexTitle">
        <h2>System</h2>

        <div className="d-flex">
          <label class="label_large me-3">Allow Notification</label>
          <div class="form-check form-switch">
            <input
              class="form-check-input"
              type="checkbox"
              checked={allowNot}
              onClick={(e) => handleAuto(e)}
            />
          </div>
        </div>
      </div>
      <div className="notification_panel">
        {allowNot &&
          notData &&
          notData.length > 0 &&
          notData.map((item, i) => {
            return (
              <div>
                <h4>
                  {item.exchange} {item.pairName} {item.issue.toLowerCase()}
                </h4>
                <h5>Date {dateTimeFormat(item.createdAt)}</h5>
              </div>
            );
          })}
      </div>
      <br />
      {allowNot && noOfPages > 1 ? (
        <ul class="pagination">
          {/* <li class="page-item">
            <button
              class="page-link"
              onClick={onPrevPage}
              disabled={!canGoBack}
            >
              {"<<"}
            </button>
          </li>
          {pagesArr.map((num, index) => (
            <li class="page-item">
              <button class="page-link" onClick={() => onPageSelect(index + 1)}>
                {index + 1}
              </button>
            </li>
          ))}
          <li class="page-item">
            <button
              class="page-link"
              onClick={onNextPage}
              disabled={!canGoNext}
            >
              {">>"}
            </button>
          </li> */}
          <span>
            Page{" "}
            <strong>
              {page} - {pagesArr.length}
            </strong>{" "}
          </span>
          &nbsp;&nbsp;
          <button onClick={() => gotoPage(1)} disabled={!canGoBack}>
            {"<<"}
          </button>{" "}
          <button onClick={onPrevPage} disabled={!canGoBack}>
            {"<"}
          </button>{" "}
          <button onClick={onNextPage} disabled={!canGoNext}>
            {">"}
          </button>{" "}
          <button onClick={() => gotoPage(noOfPages)} disabled={!canGoNext}>
            {">>"}
          </button>{" "}
        </ul>
      ) : null}
    </div>
  );
}
